import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M6.147 6.146c.195-.195.512-.195.707 0s.195.512 0 .707L4.708 9h11.793c.276 0 .5.222.5.499s-.224.501-.5.501H4.708l2.146 2.146c.195.195.195.512 0 .707a.4985.4985 0 0 1-.707 0l-3-3a.5003.5003 0 0 1 0-.707l3-3z',
  ],
  height: 20,
  width: 20,
});
